import React, { createContext, useState, useEffect } from "react";

// Create Context
export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Ensure default theme is "light" if not set in localStorage
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");

  // Function to toggle theme
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  // Apply theme to document
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.body.classList.toggle("dark", theme === "dark"); // Ensure body class is toggled
    // console.log("Current Theme:", theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
